<template>
  <m-endless-scroll-list
    class="goal-update-list"
    @visible="loadMore"
  >
    <goal-update-editor
      v-for="(update) in filteredUpdates.slice(0, amountOfItems)"
      :key="update.uid"
      :update="update"
      :goal="goal"
      :goal-children="goalChildren"
      :allow-comments="update.goalActivities.length === 0 || update.goal === null"
      :allow-goal-activity="update.goalActivities.length > 0 || update.goal === null"
      initial-disabled
      :read-only="readOnly"
    />
  </m-endless-scroll-list>
</template>

<script>
import GoalUpdateEditor from '@/components/goal/GoalUpdateEditor.vue';

export default {
  name: 'GoalUpdateList',
  props: {
    updates: {
      type: Array,
      required: true,
    },
    goal: {
      type: Object,
      required: true,
    },
    goalChildren: {
      type: Array,
      default: () => [],
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: { GoalUpdateEditor },
  data() {
    return { loadingUpdates: false, amountOfItems: 10 };
  },
  computed: {
    filteredUpdates() {
      return this.updates.filter((u) => u.message !== '').reverse();
    },
  },
  methods: {
    loadMore() {
      this.amountOfItems += 10;
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .goal-update-list {
    display: flex;
    flex-direction: column;
    gap: 1.2rem;
  }
</style>
